<template>
  <div class="container">
    <div
      v-show="message.state"
      class="alert alert-dismissible border-0 fade show"
      :class="message.type"
      role="alert"
    >
      <button
        type="button"
        class="close"
        data-dismiss="alert"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <strong>{{ message.msg }}</strong>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <form>
              <h2 class="card-title">Multimedia and social networks</h2>
              <br />
              <br />
              <div class="form-row">
                <div class="form-group col-md-6">
                  <div class="form-group col-md-12">
                    <!--start-->
                    <div class="row">
                      <div class="col-md-12">
                        <label>Website</label>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-1 col-sm-1 col-xs-1">
                        <img
                          src="../../../public/icons/WWW.png"
                          alt="web icon"
                          style="width: 24px; height:6px;"
                        />
                      </div>
                      <div class="col-md-11 col-sm-11 col-xs-11">
                        <input
                          v-model="asset_website"
                          disabled
                          type="text"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <!--end -->
                  </div>

                  <div class="form-group col-md-12">
                    <!--start-->
                    <div class="row">
                      <div class="col-md-12">
                        <label>Facebook</label>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-1 col-sm-1 col-xs-1">
                        <img
                          src="../../../public/icons/facebook.png"
                          alt="facebook icon"
                        />
                      </div>
                      <div class="col-md-11 col-sm-11 col-xs-11">
                        <input
                          v-model="asset_facebook"
                          disabled
                          type="text"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <!--end -->
                  </div>

                  <div class="form-group col-md-12">
                    <!--start-->
                    <div class="row">
                      <div class="col-md-12">
                        <label>Instagram</label>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-1 col-sm-1 col-xs-1">
                        <img
                          src="../../../public/icons/instagram.png"
                          alt="instagram icon"
                        />
                      </div>
                      <div class="col-md-11 col-sm-11 col-xs-11">
                        <input
                          v-model="asset_instagram"
                          disabled
                          type="text"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <!--end -->
                  </div>

                  <div class="form-group col-md-12">
                    <!--start-->
                    <div class="row">
                      <div class="col-md-12">
                        <label>LinkedIn</label>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-1 col-sm-1 col-xs-1">
                        <img
                          src="../../../public/icons/linkedin.png"
                          alt="linkedin icon"
                        />
                      </div>
                      <div class="col-md-11 col-sm-11 col-xs-11">
                        <input
                          v-model="asset_linkedin"
                          disabled
                          type="text"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <!--end -->
                  </div>

                  <div class="form-group col-md-12">
                    <!--start-->
                    <div class="row">
                      <div class="col-md-12">
                        <label>Medium</label>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-1 col-sm-1 col-xs-1">
                        <img
                          src="../../../public/icons/medium.png"
                          alt="medium icon"
                        />
                      </div>
                      <div class="col-md-11 col-sm-11 col-xs-11">
                        <input
                          v-model="asset_medium"
                          disabled
                          type="text"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <!--end -->
                  </div>
                </div>

                <!-- Alert Photo Limit -->
                <div class="col-md-6">
                  <div
                    v-show="disabled_photos"
                    class="alert alert-dismissible border-0 fade show alert-danger"
                    role="alert"
                  >
                    <button
                      type="button"
                      class="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <strong>{{ disabled_photos_text }}</strong>
                  </div>
                  <h4>Photos</h4>

                  <!--configuración del carrusel-->
                  <carousel
                    :pagination-enabled="true"
                    :navigation-enabled="true"
                    :min-swipe-distance="2"
                    :pagination-padding="4"
                    :pagination-size="4"
                    :per-page-custom="[
                      [768, 2],
                      [1024, 4],
                    ]"
                  >
                    <!--cada foto es un elemento slide-->
                    <slide
                      v-for="(image, key) in list_Photos"
                      :key="key"
                      style="width: 100px; height:100px; margin-left: 5px;"
                      class="img-fluid"
                    >
                      <!--photo es una variable interna que contene al base64 
                    acá se ahce la previsualización-->
                      <img
                        :src="image.photo"
                        class="img-fluid"
                        alt=""
                        style="width: 100px; height:100px;"
                      />
                    </slide>
                  </carousel>
                  <br />
                  <h4>Blueprints</h4>
                  <br />
                  <!--configuración del carrusel-->
                  <carousel
                    :pagination-enabled="true"
                    :navigation-enabled="true"
                    :min-swipe-distance="2"
                    :pagination-padding="4"
                    :pagination-size="4"
                    :per-page-custom="[
                      [768, 2],
                      [1024, 4],
                    ]"
                  >
                    <!--cada foto es un elemento slide-->
                    <slide
                      v-for="(image, key) in list_Plans"
                      :key="key"
                      style="width: 100px; height:100px; margin-left: 5px;"
                      class="img-fluid"
                    >
                      <!--photo es una variable interna que contene al base64 
                    acá se ahce la previsualización-->
                      <img
                        :ref="'plans'"
                        class="img-fluid"
                        alt=""
                        style="width: 100px; height:100px;"
                      />
                    </slide>
                  </carousel>
                </div>
                <div class="col-md-6"></div>
              </div>
              <p></p>
              <p></p>

              <div class="form-group col-md-6">
                <!--start-->
                <div class="row">
                  <div class="col-md-12">
                    <label>360° View</label>
                  </div>
                  <p class="text-secondary ml-3">
                    Upload a video on YouTube where a 360° tour of the property
                    is made and copy the link below:
                  </p>
                </div>
                <div class="row">
                  <div class="col-md-1 col-sm-1 col-xs-1">
                    <img
                      src="../../../public/icons/reload.png"
                      alt="reload icon"
                      class="mr-4"
                    />
                  </div>
                  <div class="col-md-11 col-sm-11 col-xs-11">
                    <input
                      v-model="asset_video"
                      disabled
                      type="text"
                      class="form-control"
                      @change="loadVideo($event.target.value)"
                    />
                  </div>
                </div>
                <!--end -->
              </div>

              <div v-if="asset_video != ''" class="ml-3 mt-3">
                <youtube-media
                  :video-id="asset_video"
                  player-width="580"
                  player-height="360"
                ></youtube-media>
              </div>
            </form>
            <div class="text-right">
              <br />
              <br />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getIdFromURL } from 'vue-youtube-embed';
import { Carousel, Slide } from 'vue-carousel';
export default {
  name: 'AssetMultimedia',
  components: {
    Carousel,
    Slide,
  },
  data() {
    return {
      message: {
        state: false,
        msg: '',
        type: '',
      },
      userId: '',
      assetId: '',
      asset_website: '',
      asset_facebook: '',
      asset_instagram: '',
      asset_linkedin: '',
      asset_medium: '',
      asset_video: '',
      photos: 'Photos',
      plans: 'Plans',
      list_Photos: [],
      list_Plans: [],
      text_photos: 'Drag your photos here',
      text_plans: 'Drag your photos here',
      disabled_photos: false,
      disabled_photos_text: '',
      disabled_Plans: false,
      send_data: false,
      send_files: false,
    };
  },
  created() {
    this.userId = JSON.parse(localStorage.getItem('user')).userId;
    this.assetId = this.$store.state.assetId;
    this.getData();
  },
  methods: {
    loadVideo(url) {
      this.asset_video = getIdFromURL(url);
    },
    getData() {
      this.$http
        .get(`/asset/Multimedia/Data?assetId=${this.assetId}`)
        .then(({ data }) => {
          this.userId = data.AssetMult.userId;
          this.assetId = data.AssetMult.assetId;
          this.asset_website = data.AssetMult.webLink;
          this.asset_facebook = data.AssetMult.facebookLink;
          this.asset_linkedin = data.AssetMult.linkedinLink;
          this.asset_instagram = data.AssetMult.instagramLink;
          this.asset_medium = data.AssetMult.mediumLink;
          this.asset_video = data.AssetMult.youtubeVideo;
        })
        .catch(err => {
          this.message.msg = err.response.data.message;
          this.message.type = 'alert-warning';
          this.message.state = true;
          this.scrollNavigator();
        });
    },
  },
};
</script>

<style scoped>
@import './styles/slider.css';
.dropzone {
  height: 120px;
  padding: 10px;
  position: relative;
  cursor: pointer;
  outline: 2px dashed grey;
  outline-offset: -5px;
  background: #f4f5f7;
  color: dimgray;
}
.input-file {
  opacity: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  cursor: pointer;
}
.dropzone:hover {
  background: #b9c6f6;
}

.dropzone .call-to-action {
  font-size: 1.2rem;
  text-align: center;
  padding-top: 10px;
}
</style>
